import React, { useState, useRef } from "react";
import { Table } from "antd";
import { Icon } from "@iconify/react";
import DelTableRowModal from "../../modals/delTableRowModal";
import { Select } from "antd";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CaseDetailModal from "../../modals/caseDetailModal";
import Button from "../../components/shared/button";
import AddNewModal from "../../modals/addnewPlanModal";
import { useTranslation } from "react-i18next";

const Plans = () => {
  const { t } = useTranslation();
  const { Option } = Select;
  const [selectedDate, setSelectedDate] = useState(new Date());
  const datePickerRef = useRef(null); // Create a ref for DatePicker
  const [isdelModalOpen, setIsdelModalOpen] = useState(false);
  const [planModelOpen, setplanModelOpen] = useState(false);
  const [iscaseDetailOpen, setiscaseDetailOpen] = useState(false);
  const status = ["Active", "InActive"];
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  const onDelClick = () => {
    setIsdelModalOpen(true);
  };
  const onAddnewClick = () => {
    setplanModelOpen(true);
  };
  const onviewClick = () => {
    setiscaseDetailOpen(true);
  };
  const handleIconClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setFocus();
    }
  };

  const data = [
    {
      key: "1",
      title: "Basic",
      duration: "30 days",
      dateAdded: "Mon Oct 7, 2024 11:30 am",
      status: "Active",
    },
    {
      key: "2",
      title: "Premium",
      duration: "30 days",
      dateAdded: "Mon Oct 7, 2024 11:30 am",
      status: "Active",
    },
    {
      key: "3",
      title: "Unlimited",
      duration: "30 days",
      dateAdded: "Mon Oct 7, 2024 11:30 am",
      status: "Active",
    },
  ];

  const columns = [
    {
      title: t("adminDashboard.plans.title"),
      dataIndex: "title",
      key: "title",
      render: (text) => <span className="text-[#000] font-medium">{text}</span>,
    },
    {
      title: t("adminDashboard.plans.duration"),
      dataIndex: "duration",
      key: "duration",
      render: (text) => <span className="text-[#000] font-medium">{text}</span>,
    },
    {
      title: t("adminDashboard.plans.dateAdded"),
      dataIndex: "dateAdded",
      key: "dateAdded",
      render: (text) => <span className="text-[#000] font-medium">{text}</span>,
    },
    {
      title: t("adminDashboard.plans.status"),
      dataIndex: "status",
      key: "status",
      render: (text) => (
        <Select placeholder="Year" style={{ width: 135 }} className="status-dropdown">
          {status.map((month, index) => (
            <Option key={index} value={month}>
              {month}
            </Option>
          ))}
        </Select>
      ),
    },
    {
      title: t("adminDashboard.plans.actions"),
      key: "actions",
      render: () => (
        <div className="flex gap-[8px] items-center">
          <img
            src="../../assets/icons/eye.png"
            alt="View"
            className="cursor-pointer w-[34px] h-[34px]"
            onClick={onviewClick}
          />
          <img
            src="../../assets/icons/edit1.png"
            alt="edit"
            className="cursor-pointer w-[34px] h-[34px]"
            // onClick={onviewClick}
          />

          <img
            src="../../assets/icons/del.png"
            alt="Delete"
            className="cursor-pointer w-[34px] h-[34px]"
            onClick={onDelClick}
          />
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="files-main py-[43px] flex flex-col gap-[22px]">
        <div className="top flex items-center justify-between ">
          <h5 className="text-blue font-bold">{t("adminDashboard.plans.title")}</h5>
          <Button
            text={t("adminDashboard.plans.addnew")}
            className="button btn-blue !rounded-[29px] medium"
            height={45}
            width={137}
            img="line-md:plus"
            clr="white"
            onClick={onAddnewClick}
          />
        </div>
        <div className="bottom">
          <div className="filter-div bg-white rounded-t-[20px] max-sm:gap-[10px] gap-[20px] flex items-center justify-between max-sm:flex-col max-sm:justify-center py-[22px] pr-[20px] pl-[15px]">
            <div className="left-div gap-[20px] flex items-center max-sm:gap-[10px]">
              <Icon icon="solar:filter-bold-duotone" color="#143A62" width={22} height={22} />
              <div className="flex gap-[8px] items-center">
                <p className="small font-medium">{t("adminDashboard.plans.date")}:</p>
                <div className="flex items-center gap-[10px] rounded-[10px] p-[10px] border-[var(--stroke-weight-1,1px)]  bg-[#F0F0F0]">
                  <DatePicker
                    selected={selectedDate}
                    onChange={handleDateChange}
                    className="text-[#8D8D8D] bg-transparent font-medium small font-montserrat"
                    dateFormat="MM/dd/yyyy"
                    ref={datePickerRef} // Assign the ref to DatePicker
                  />
                  <Icon
                    icon="clarity:date-line"
                    className="text-gray-500 cursor-pointer"
                    onClick={handleIconClick} // Trigger DatePicker on icon click
                  />
                </div>
              </div>
            </div>
            <div className="py-[15px] flex items-center gap-[5px] border-b border-solid border-b-[#B8C0CB]">
              <input type="search" name="" id="" placeholder={t("adminDashboard.plans.search")} />
              <Icon icon="si:search-line" color="#143A62" width={22} height={22} />
            </div>
          </div>
          <Table
            columns={columns}
            dataSource={data}
            pagination={{
              position: ["bottomCenter"],
              pageSize: 6,
              itemRender: (current, type, originalElement) => {
                if (type === "prev") {
                  return (
                    <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                      <Icon icon="ep:arrow-left-bold" color="#143A62" />
                    </div>
                  );
                }
                if (type === "next") {
                  return (
                    <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                      <Icon icon="ep:arrow-right-bold" color="#143A62" />
                    </div>
                  );
                }
                return originalElement;
              },
              showSizeChanger: false,
            }}
            className="w-full admin-dashboardTables"
            scroll={{ x: "1000px" }}
          />
        </div>
      </div>
      <DelTableRowModal isdelModalOpen={isdelModalOpen} setIsdelModalOpen={setIsdelModalOpen} />
      <CaseDetailModal
        iscaseDetailOpen={iscaseDetailOpen}
        setiscaseDetailOpen={setiscaseDetailOpen}
      />
      <AddNewModal planModelOpen={planModelOpen} setplanModelOpen={setplanModelOpen} />
    </>
  );
};

export default Plans;
